module.exports = __webpack_public_path__ + "static/img/Michael.Hibberd.466206f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael.Hibberd.jpg
// module id = YTvC
// module chunks = 0